var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sys-edit" }, [
    _c(
      "div",
      { staticClass: "dialog-body" },
      [
        _c(
          "el-form",
          {
            ref: "formSys",
            staticStyle: {
              display: "flex",
              "flex-wrap": "wrap",
              "justify-content": "space-between"
            },
            attrs: {
              "label-position": "top",
              model: _vm.formSys,
              rules: _vm.rules,
              "label-width": "120px"
            }
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "系统类型：", prop: "systemType" } },
              [
                _c(
                  "el-select",
                  {
                    attrs: { size: "small", placeholder: "请选择系统类型" },
                    model: {
                      value: _vm.formSys.systemType,
                      callback: function($$v) {
                        _vm.$set(_vm.formSys, "systemType", $$v)
                      },
                      expression: "formSys.systemType"
                    }
                  },
                  _vm._l(_vm.typelist, function(option, i) {
                    return _c("el-option", {
                      key: i,
                      attrs: { label: option.value, value: option.key }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "系统域名：" } },
              [
                _c("el-input", {
                  staticClass: "limit256",
                  attrs: {
                    size: "small",
                    placeholder: "请输入系统域名",
                    maxlength: "256",
                    "show-word-limit": ""
                  },
                  model: {
                    value: _vm.formSys.baseUrl,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.formSys,
                        "baseUrl",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "formSys.baseUrl"
                  }
                })
              ],
              1
            ),
            _vm.ifSubSysEdit
              ? _c(
                  "el-form-item",
                  {
                    attrs: { label: "系统状态", prop: "systemCategoryStatus" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { size: "small", placeholder: "请选择系统状态" },
                        model: {
                          value: _vm.formSys.systemCategoryStatus,
                          callback: function($$v) {
                            _vm.$set(_vm.formSys, "systemCategoryStatus", $$v)
                          },
                          expression: "formSys.systemCategoryStatus"
                        }
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "有效", value: "VALID" }
                        }),
                        _c("el-option", {
                          attrs: { label: "失效", value: "INVALID" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "dialog-footer", staticStyle: { "margin-top": "0px" } },
      [
        _c(
          "el-button",
          { staticClass: "btn", on: { click: _vm.cancelDailog } },
          [_vm._v("取消")]
        ),
        _c(
          "el-popconfirm",
          {
            attrs: {
              title: _vm.ifSubSysEdit
                ? "确认修改此子系统？"
                : "确认添加此子系统"
            },
            on: {
              onConfirm: function($event) {
                return _vm.confirmsure(true)
              },
              onCancel: function($event) {
                return _vm.confirmsure(false)
              }
            }
          },
          [
            _c("input", {
              staticClass: "btn btn-red",
              attrs: { slot: "reference", type: "button", value: "确认" },
              slot: "reference"
            })
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }